import { render, staticRenderFns } from "./connect.vue?vue&type=template&id=6fd01d44"
import script from "./connect.vue?vue&type=script&lang=js"
export * from "./connect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports